import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import packageJson from '../../package.json';

export default function LandingPage() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
        bgcolor: 'grey.50',
      }}
    >
      <Paper sx={{ maxWidth: 480, width: '100%', p: 4, textAlign: 'center' }}>
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL || ''}/wh-logo.png`}
          alt="Walter Hill Church of Christ"
          sx={{ height: 56, display: 'block', mx: 'auto', mb: 3 }}
        />
        <Typography variant="h5" color="primary" gutterBottom sx={{ fontWeight: 600 }}>
          Involvement Preferences
        </Typography>
        <Typography variant="body1" color="text.primary" paragraph>
          There are so many ministries and opportunities to serve at Walter Hill.
        </Typography>
        <Typography variant="body1" color="text.primary" fontWeight={600}>
          See Kip Nickell or Trey England to get started.
        </Typography>
        <Typography variant="body1" color="text.primary" fontWeight={100}>
          They will send you a form to fill out.  
        </Typography>
        <Typography
          variant="caption"
          component="div"
          color="text.secondary"
          textAlign="center"
          sx={{ mt: 4, opacity: 0.8 }}
        >
          v{packageJson.version}
        </Typography>
      </Paper>
    </Box>
  );
}
